import { Card } from "antd";

export default function MyCard({ children, ...props }) {

    const styles = {
        myCardHeadStyle: {
            borderRadius: 30,
            borderWidth: 1,
            borderColor: 'black',
            width: '67%',
            color: 'white',
            backgroundColor: '#84F22E',
            textAlign:'center'
        },
        myCardStyle: {
            borderRadius: 20,
            borderWidth: 5,
            width: "100%",
            height: "100%",
            boxSizing: 'border-box'
        },
    }


    return (
        <Card type="inner" style={styles.myCardStyle} headStyle={styles.myCardHeadStyle} {...props} >
            {children}
        </Card >
    )
}